var $ = require('jquery');
var logo_anim = require('logo-anim');
var cymasmooth = require('cymasmooth');
require('wrapmask');
var isLeft = require('is-left');
var MQ = require('mq');
var shuffle = require('shuffle');

function splitLinesFromBr(el) {
    const linesHTML = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = ''; // On vide le conteneur

    // On transforme chaque segment en éléments DOM et on les stocke dans un array
    const lineElements = linesHTML.map(lineContent => {
        const lineWrapper = document.createElement('div');
        lineWrapper.className = 'split-line-wrapper';
        // lineWrapper.style.overflow = 'hidden';
        
        const lineInner = document.createElement('div');
        lineInner.className = 'line-inner';
        // lineInner.style.display = 'inline-block';
        lineInner.innerHTML = lineContent.trim();
        
        lineWrapper.appendChild(lineInner);
        el.appendChild(lineWrapper);
        
        return lineInner; // On retourne l'élément qu'on veut vraiment animer
    });

    return lineElements; // Array utilisable directement par GSAP
}

$('body').on('reveal-eos-slideshow', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.8, force3D: true }});
	tl.from($(el).find('.home__slideshow__group__galerie__item__inner'), {
		x: '-50px',
		opacity: 0,
		stagger: 0.1
	})
	setTimeout(function() {
		tl.play();
	}, 200);
});

$('body').on('reveal-eos-certifs', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.home__certifications__group__blocs__item').each(function(i, el){
		var distFromCenter = Math.floor(Math.abs(i - 3.5));
		var delay = distFromCenter * 0.1;
		tl.fadeUp(el, {}, delay);
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-eos-intro', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	tl.fadeUp( $(el).find('.home__intro__logo, .home__intro__group__un__ensemble__immobilier, .home__intro__group__visionnaire, .home__intro__group__adresse'), {

	}, 0.1 );
	if (MQ(768)) {
		tl.from( $(el).find('.home__intro__group__visuel__wrap__wrap'), {
			opacity: 0.01,
			scale: 1.2,
			transformOrigin: '50% 100%',
			duration: 2,
			ease: 'power2.inOut'
		}, 0 )
		tl.fadeUp( $(el).find('.home__intro__group__lettres__lettre'), {
			yOrigin: -50,
		}, MQ(768) ? 2 : 1.1 );
		tl.fadeUp( $(el).find('.home__intro__group__lettres__texte__2'), {
			yOrigin: -50,
		}, MQ(768) ? 3 : 2.1 );
		tl.fadeUp( $(el).find('.home__intro__group__lettres__texte__1, .home__intro__group__lettres__date'), {
			yOrigin: 0,
			stagger: 0
		}, MQ(768) ? 4 : 3.1 );
	}
	else {
		// tl.from( $(el).find('.home__intro__group__visuel'), {
		// 	opacity: 0.01,
		// 	scale: 1.1,
		// 	transformOrigin: '50% 100%',
		// 	duration: 2,
		// 	ease: 'power2.inOut'
		// }, 0 )
		// tl.fromTo( $(el).find('.home__intro__group__lettres__lines line'), {
		// 	drawSVG:'100% 100%'
		// }, {
		// 	drawSVG:'0% 100%',
		// 	duration: 1
		// }, 1.1 )
		// tl.from( $(el).find('.home__intro__group__lettres__lines line'), {
		// 	opacity: 0,
		// 	stagger: 0.1,
		// 	ease: 'none',
		// 	duration: 1,
		// }, 1.1 )
	}
	
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-headerpagebb', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.inner').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 1.1,
			duration: 2.5,
			stagger: 0.07,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-headerpageb', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.headerpageb__page__header__group__corus, .headerpageb__page__header__group__titre, .headerpageb__page__header__group__sous__titre').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagen-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagen__header__group__titre, .pagen__header__group__sous__titre, .pagen__header__group__texte').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	tl.fadeUp( $(el).find('.pagen__header__group__blocs__item'), {
		yOrigin: '50rem',
		duration: 1.5,
		stagger: 0.07,
	}, 0.4 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagev-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagev__header__group__titre, .pagev__header__group__texte').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagej-body', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$('.pagej__bloc__group > div').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 0.9,
			duration: 2.5,
			stagger: 0.15,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagej-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagej__header__group__titre, .pagej__header__group__texte, .pagej__header__group__blocs__bloc').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagei-body', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagei__bloc__group__video .bloc__video').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 1.1,
			duration: 2.5,
			stagger: 0.07,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pagei-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagei__header__group__titre, .pagei__header__group__sous__titre, .pagei__header__group__texte').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-pageh-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pageh__header__group__titre, .pageh__header__group__texte').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	$(el).find('.pageh__bloc__group__plan .inner').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 1.1,
			duration: 2.5,
			stagger: 0.07,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-campus-headerpage', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.headerpage__page__header__group__titre, .headerpage__page__header__group__sous__titre, .headerpage__page__header__group__texte').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, i * 0.1 );
	});
	tl.fadeUp( $(el).find('.headerpage__page__header__group__visuel'), {
		yOrigin: '50rem',
		duration: 1.5,
		stagger: 0.07,
	}, 0.3 );
	$(el).find('.headerpage__page__header__group__video .bloc__video').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 1.1,
			duration: 2.5,
			stagger: 0.07,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pagea-header', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	$(el).find('.pagea__bloc__1__group__titre').each(function(i, el){
		var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, 0 );
	});
	tl.fadeUp( $(el).find('.pagea__bloc__1__group__visuel'), {
		yOrigin: '50rem',
		duration: 1.5,
		stagger: 0.07,
	}, 0.1 );
	$(el).find('.pagea__bloc__1__group__blocs__item').each(function(i, el){
		var lines = new SplitText($(el).find('.pagea__bloc__1__group__blocs__titre .inner'), {type:'lines'}).lines;
		var linesb = new SplitText($(el).find('.pagea__bloc__1__group__blocs__texte .inner'), {type:'lines'}).lines;
		lines = $(lines).add(linesb);
		tl.fadeUp( lines, {
			yOrigin: '50rem',
			duration: 1.5,
			stagger: 0.07,
		}, 0.2 + (i *0.1) );
	});
	$(el).find('.pagea__bloc__1__group__video .bloc__video').each(function(i, el){
		$(el).addClass('wc');
		tl.from( el, {
			opacity: 0,
			scale: 1.1,
			duration: 2.5,
			stagger: 0.07,
		}, 0 );
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-home-slide', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	// var lines = new SplitText($(el).find('.inner p'), {type:'lines'}).lines;
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( $(el).find('.home__slides__titre'), {
		// yOrigin: '50rem',
		yOrigin: 0,
		xOrigin: '-50rem',
		duration: 1.5,
		stagger: 0.1,
	}, 0 );
	tl.fadeUp( $(el).find('.thumbnail__group__inner'), {
		yOrigin: 0,
		xOrigin: '-50rem',
		duration: 1.5,
		stagger: 0.1,
	}, 0.2 );
	tl.fadeUp( $(el).find('.slideshow__arrows'), {
		yOrigin: 0,
		xOrigin: 0,
		duration: 1,
		stagger: 0,
	}, 0.5 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-lines', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( lines, {
		yOrigin: '50rem',
		duration: 1.5,
		stagger: 0.1,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-lines-p', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	var lines = new SplitText($(el).find('.inner p'), {type:'lines'}).lines;
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( lines, {
		yOrigin: '50rem',
		duration: 1.5,
		stagger: 0.1,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-mr-percent', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	var chars = new SplitText($(el).find('.methode__chiffres__group__augmentation__group__chiffres__pourcentage .inner'), {type:'lines,words,chars'}).chars;
	var last = chars.pop();
	console.log('chars', chars);
	console.log('last', last);
	tl.fadeUp( chars, {
		stagger: 0.1
	}, 0);
	tl.chiffre( chars, {
		stagger: 0.1
	}, 0);
	tl.fadeUp( last, {
		stagger: 0.1
	}, 0.3);
	tl.from( $(el).find('.methode__chiffres__group__augmentation__group__chiffres__line .inner'), {
		xPercent: -101,
		duration: 0.7,
	}, 0.4);
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-em-artist-creative', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});

	tl.fadeUp( $(el).find('.em-artist-creative'), {
		duration: 1.7,
	});

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-em-lines', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});

	// On cherche la valeur du data-attribute sur l'élément (ou sur l'élément .inner)
	var customThreshold = el.data('line-threshold'); 

	// Configuration de base de SplitText
	var splitConfig = { type: 'lines' };

	// Si l'attribut existe, on l'ajoute à l'objet de config
	if (customThreshold !== undefined) {
	    splitConfig.lineThreshold = customThreshold;
	}

	var lines = new SplitText(el.find('.inner'), splitConfig).lines;
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	
	tl.from( lines, {
		y: '50rem',
		opacity: 0,
		duration: 1.2,
		clearProps: 'transform',
		stagger: 0.1,
	}, 0 );

	// tl.fadeUp( lines, {
		
	// }, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-em-testimonials', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	tl.from( $(el).find('.testimonials__bloc__testimonials__group__elements__item__line .inner'), {
		x: '-100%',
		stagger: 0.06,
		duration: 1.3,
	});
	
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-em-collections-options', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	tl.from( $(el).find('.our__collections__group__options__group__blocs__elements__item__line .inner'), {
		x: '-100%',
		stagger: 0.06,
		duration: 1.3,
	});
	
	setTimeout(function() {
		tl.play();
	}, 10);
});

// moved to home modelanim
$('body').on('reveal-em-projet', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});
	tl.from( $('.projetspost__visuels__group__groupes__items'), {
		opacity: 0,
		ease: 'none',
	}, 0)
	if ( MQ(768) ) {
		tl.fadeUp( $('.projetspost__titre, .slideshow__nbs__wrap, .projetspost__visuels__group__groupes__items__navs'), {
			duration: 1.2
		}, 0.2)
		tl.from( $('.projetspost__infos__back'), {
			x: '50rem',
			opacity: 0,
		}, 0.3)
		tl.from( $('.projetspost__infos__credits'), {
			x: '-50rem',
			opacity: 0,
		}, 0.3)
	}
	else {
		tl.fadeUp( $('[data-reveal-xs-order]').sortCustom('data-reveal-xs-order'), {
			duration: 1.2
		}, 0.2)
		tl.from( $('.projetspost__visuels__group__groupes__items__arrow.prev'), {
			x: '30rem',
			opacity: 0,
		}, 0.6)
		tl.from( $('.projetspost__visuels__group__groupes__items__arrow.next'), {
			x: '-30rem',
			opacity: 0,
		}, 0.6)
	}
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-em-projets', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.projets__taxo__item .inner'), {
		duration: 1.3
	})

	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-em-home', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText($(el).find('.home__texte .inner'), {type:'lines'}).lines;
	$(lines).each(function(i, line){
		tl.fadeUp(line, {
			stagger: 0.1,
			duration: 1.7 - i * 0.1,
			ease: 'power3.out',
		}, i * 0.1);
	})

	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-em-collection-intro-old', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});

	var splitConfig = { type: 'lines,words,chars' };
	var charsA = new SplitText(el.find('.intro__group__titre'), splitConfig).chars;
	var charsB = new SplitText(el.find('.intro__group__sous__titre .inner'), splitConfig).chars;

	var chars = $(charsA).add(charsB).addClass('wc');

	tl.from( chars, {
		scale:0.5,
		opacity: 0,
		duration: 2.9,
		stagger: 0.01
	}, 0);

	var ways = [
		{x:-101,y:0},
		{x:101,y:0},
		{x:0,y:-101},
		{x:0,y:101},
	];
	var els = $(el).find('.intro__group__gallerie__item .inner');
	if ( MQ(-768) ) {
		$(el).find('.intro__group__gallerie__item:not(.not__pho) .inner');
	}
	els.each(function(i, el){
		var randomWays = ways[Math.floor(Math.random() * 4)];
		tl.from(el , {
			xPercent: randomWays.x,
			yPercent: randomWays.y,
			duration: 1.2
		}, 0.5 + (i*0.015));
	});

	if ( MQ(-768) ) {
		tl.add(function(){
			$(window).trigger('collection-intro-done');
		});
	}
	
	
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-em-collection-intro', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "power2.out", duration: 1.2, force3D: true }});

	tl.fadeUp(el.find('.intro__group__titre, .intro__group__sous__titre'), {
		duration: 1.2,
		ease: 'power2.out',
	});

	var $els = $(el).find('.intro__group__gallerie__item .inner');
	if ( MQ(-768) ) {
		$els = $(el).find('.intro__group__gallerie__item:not(.not__pho) .inner');
	}

	tl.from( $els.shuffle(), {
		opacity: 0,
		stagger: 0.015,
		ease: 'none',
		duration: 1.2,
	}, 0.5 );

	if ( MQ(-768) ) {
		tl.add(function(){
			$(window).trigger('collection-intro-done');
		});
	}
	
	
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-lines', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});

	// On cherche la valeur du data-attribute sur l'élément (ou sur l'élément .inner)
	var customThreshold = el.data('line-threshold'); 

	// Configuration de base de SplitText
	var splitConfig = { type: 'lines' };

	// Si l'attribut existe, on l'ajoute à l'objet de config
	if (customThreshold !== undefined) {
	    splitConfig.lineThreshold = customThreshold;
	}

	var lines = new SplitText(el.find('.inner'), splitConfig).lines;
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( lines, {
		
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-logos', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	$(window).trigger('qw-logo-start-ticker');
	var tl = new TimelineMax({paused : true});
	tl.to( $(el).find('.experience__histoires__group__visuels__item'), {
		x: 0,
		y: 0,
		stagger: 0.02,
		duration: 1.7,
		ease: 'power3.out',
	}, 0);

	setTimeout(function() {
		tl.play();
	}, 200);
});

$('body').on('reveal-qw-window', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	tl.from( $(el).find('.inner'), {
		scale: 1/1.5,
		duration: 0.7,
		stagger: 0.2,
	}, 0);

	tl.from( $(el).find('.inner__inner'), {
		scale: 1.5,
		duration: 0.7,
		stagger: 0.2,
	}, 0);

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-temoignages', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var $item = $(el).find('.swiper-slide-active');
	// el = $(el).find('.swiper-slide-active');
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	tl.fadeUp( $item.find('.about__temoignages__group__temoignages__visuel__1, .about__temoignages__group__temoignages__visuel__2'), {

	}, 0);
	var lines = new SplitText($item.find('.about__temoignages__group__temoignages__texte .inner'), {type:'lines'}).lines;
	$item.find('.about__temoignages__group__temoignages__texte').data('lines', lines);
	// var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( lines, {
		// yOrigin: '101%',
		// duration: 1.5,
		// stagger: 0.1,
	}, 0.2);
	tl.fadeUp( $item.find('.about__temoignages__group__temoignages__signature'), {

	}, 0.5);
	tl.fadeUp( $(el).find('.about__temoignages__group__temoignages__items__navs'), {

	}, 0.7);
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-lines-hidden-p', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	var lines = new SplitText($(el).find('.inner p'), {type:'lines'}).lines;
	var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( wrapmask.childs, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.1,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-lines-hidden', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
	var wrapmask = $(lines).wrapmask({cn:'ovh rel line'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( wrapmask.childs, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.1,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-qw-home-intro', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	var wrapmask = $(el).find('.home__intro__group__mots .inner').wrapmask({cn:'ovh rel'});
	var wrapmaskb = $('.home__intro__group__fullname path').wrapmasksvg({
		offset: 1
	}).els;
	var wrapmaskc = $(el).find('.home__intro__group__footer .inner').wrapmask({cn:'ovh rel'});
	var els = wrapmask.childs.add(wrapmaskb).add(wrapmaskc.childs);
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( els, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.2,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-quartier-repere-txts', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	// var lines = new SplitText($(el).find('.quartier__repere__group__textes__titre p, .quartier__repere__group__textes__texte .inner'), {type:'lines,words'}).lines;
	$(el).find('.quartier__repere__group__textes__titre p, .quartier__repere__group__textes__texte .inner').addClass('wc');
	tl.from( $(el).find('.quartier__repere__group__textes__titre p, .quartier__repere__group__textes__texte .inner'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, stagger: 0.1
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-quartier-photo', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.quartier__repere__group__visuels__partie__1__visuel .inner, .quartier__repere__group__visuels__partie__2__visuel .inner').addClass('wcb');
	tl.from( $(el).find('.quartier__repere__group__visuels__partie__1__visuel .inner, .quartier__repere__group__visuels__partie__2__visuel .inner'), {
		// ease: "expo.out", 
		// duration: 2.2, 
		force3D: true,
		scale: 1.1,
		duration: 2.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	});
	$(el).find('.txt__15 .innner').addClass('wc');
	tl.from( $(el).find('.txt__15 .innner'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, stagger: 0.1
	}, '<0.1');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-ctanavs', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.ctanavs__ctas__header__group__titre').addClass('wcb');
	tl.from( $(el).find('.ctanavs__ctas__header__group__titre'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(15px)", stagger: 0.1
	}, '<0.2');
	$(el).find('.ctanavs__ctas__header__group__precedent').addClass('wc');
	tl.from( $(el).find('.ctanavs__ctas__header__group__precedent'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		x: '50rem', opacity: 0, stagger: 0.1
	}, '<0.4');
	$(el).find('.ctanavs__ctas__header__group__suivant').addClass('wc');
	tl.from( $(el).find('.ctanavs__ctas__header__group__suivant'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		x: '-50rem', opacity: 0, stagger: 0.1
	}, '<0.1');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-plans', '.scroll-reveal', function(evt){
	evt.stopPropagation();
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.plans__intro__section__bg .svg__wrap').addClass('wcb');
	tl.from( $(el).find('.plans__intro__section__bg .svg__wrap'), {
		scale: 1.1,
		duration: 3.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	}); 
	$(el).find('.plans__intro__group__tableau').addClass('wc');
	tl.from( $(el).find('.plans__intro__group__tableau'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, stagger: 0.1
	}, '<0.2');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-arrow', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	tl.from( $(el).find('[data="arrow-line"]'), {
		duration: 1.2,
		drawSVG:'0% 0%',
	} )
	tl.from( $(el).find('[data="arrow-end"]'), {
		duration: 1.2,
		opacity: 0,
	}, '<0.6' )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-header-bloc', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.headerbloc__bloc__header__item__right__inner').addClass('wcb');
	tl.from( $(el).find('.headerbloc__bloc__header__item__right__inner'), {
		scale: 1.1,
		duration: 2.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	});
	var lines = splitLinesFromBr( $(el).find('.headerbloc__bloc__header__group__titre p').get(0) );
	$(lines).addClass('wcb');
	tl.from( $(lines), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(15px)", stagger: 0.1
	}, '<0.2');
	$(el).find('.headerbloc__bloc__header__group__sous__titre').addClass('wcb');
	tl.from( $(el).find('.headerbloc__bloc__header__group__sous__titre'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(5px)", stagger: 0.1
	}, '<0.2');
	$(el).find('.headerbloc__bloc__header__group__cta').addClass('wcb');
	tl.from( $(el).find('.headerbloc__bloc__header__group__cta'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(5px)", stagger: 0.1
	}, '<0.2');
	$(el).find('.headerbloc__bloc__header__group__adresse').addClass('wc');
	tl.from( $(el).find('.headerbloc__bloc__header__group__adresse'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		x: '-50rem', opacity: 0, stagger: 0.1
	}, '<0.4');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-contact', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.contact__section__bg .svg__wrap').addClass('wcb');
	tl.from( $(el).find('.contact__section__bg .svg__wrap'), {
		scale: 1.1,
		duration: 3.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	});
	var $items = $(el).find('.contact__reveal');
	// var lines = new SplitText($(el).find('.home__intro__group__titre .inner p'), {type:'lines,words'}).lines;
	$items.addClass('wcb');
	tl.from( $items, {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, stagger: 0.1
	}, '<0.2');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-manifest', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.manifest__section__bg .svg__wrap').addClass('wcb');
	tl.from( $(el).find('.manifest__section__bg .svg__wrap'), {
		scale: 1.1,
		duration: 3.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	});
	var $items = $(el).find('.manifest__titre, .manifest__texte p');
	// var lines = new SplitText($(el).find('.home__intro__group__titre .inner p'), {type:'lines,words'}).lines;
	$items.addClass('wcb');
	tl.from( $items, {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, stagger: 0.1
	}, '<0.2');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-gf-home-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true, defaults: { ease: "expo.out", duration: 1.2, force3D: true }});
	$(el).find('.gf__logo__bg .svg__wrap').addClass('wcb');
	tl.from( $(el).find('.gf__logo__bg .svg__wrap'), {
		scale: 1.1,
		duration: 3.7,
		filter: "blur(20px)",
		opacity: 0,
		ease: 'power2.out'
	});
	// var lines = new SplitText($(el).find('.home__intro__group__titre .inner p'), {type:'lines,words'}).lines;
	var lines = splitLinesFromBr( $(el).find('.home__intro__group__titre .inner p').get(0) );
	$(lines).addClass('wcb');
	tl.from( $(lines), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(15px)", stagger: 0.1
	}, '<0.2');
	$(el).find('.home__intro__group__cta').addClass('wcb');
	tl.from( $(el).find('.home__intro__group__cta'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		y: '50rem', opacity: 0, filter: "blur(5px)", stagger: 0.1
	}, '<0.4');
	$(el).find('.home__intro__group__cta').addClass('wc');
	tl.from( $(el).find('.home__intro__adresse'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		x: '-50rem', opacity: 0, stagger: 0.1
	}, '<0.4');
	// $(el).find('.home__intro__group__cta').addClass('wc');
	tl.from( $(el).find('.home__intro__group__arrow__down__wrap'), {
		ease: "expo.out", duration: 2.2, force3D: true,
		opacity: 0, stagger: 0.1
	}, '<0.1');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-opus-map', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	// var tl = new TimelineMax({paused : true});
	// tl.from( $(el).find('.headerbloc__bloc__header__item__txts__bg'), {
	// 	duration : 1.6,
	// 	opacity: 0,
	// 	scaleX: 0.5,
	// 	ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
	// }, 0 );

	// tl.from( $(el).find('.headerbloc__bloc__header__group__sous__titre .inner div').add( $(el).find('.headerbloc__bloc__header__group__titre .inner') ), {
	// 	y: '100%',
	// 	y: function(i, el, els){
	// 		return $(el).outerHeight() * ( 1 + (i*0.25) );
	// 	},
	// 	opacity: 0,
	// 	duration: 1.6,
	// 	ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
	// 	stagger: 0.02,
	// }, 0.1)
	setTimeout(function() {
		$('.home__quartier__group__visuel__mask').addClass('is-visible');
	}, 5);
});

$('body').on('reveal-opus-lineso', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var q = $(el).attr('data-reveal-query');
	var $els = $(el).find(q);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp($els);
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-opus-lines', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var q = $(el).attr('data-reveal-query');
	var $els = $(el).find(q);
	var tl = new TimelineMax({paused : true});
	$els.addClass('wc');
	tl.from( $els, {
		// y: '100%',
		y: function(i, el, els){
			return $(el).outerHeight() * ( 1 + (i*0.25) );
		},
		opacity: 0,
		duration: 1.2,
		ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
		stagger: 0.02,
	}, 0.1)
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-opus-header-bloc', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.headerbloc__bloc__header__item__txts__bg'), {
		duration : 1.6,
		opacity: 0,
		scaleX: 0.5,
		ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
	}, 0 );

	tl.from( $(el).find('.headerbloc__bloc__header__group__sous__titre .inner div').add( $(el).find('.headerbloc__bloc__header__group__titre .inner') ), {
		// y: '100%',
		y: function(i, el, els){
			return $(el).outerHeight() * ( 1 + (i*0.25) );
		},
		opacity: 0,
		duration: 1.6,
		ease: CustomEase.create("custom", "M0,0 C0.251,0.739 0.246,1 1,1 "),
		stagger: 0.02,
	}, 0.1)
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-home', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fromTo( $(el).find('.home__video'), {
		scale: 1.3,
		opacity: 0
	}, {
		scale: 1.001,
		duration: 1.5,
		opacity: 1
	});
	var lines = new SplitText($(el).find('.home__titre .inner'), {type:'lines'}).lines;
	var $lines = $(lines).add( $(el).find('.home__titreb') );
	
	var wrapmask = $lines.wrapmask({cn:'ovh rel'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( wrapmask.childs, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.2,
	}, 0.5 )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-films', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	tl.fadeUp( $(el).find('.filmspost__content').onlyVisible(), {
		yOrigin: '101%',
		duration: 1,
		stagger: 0.2,
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-services-intro', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	var qs = ['.services__intro__group__titre .inner', '.services__intro__group__sous__titre .inner', '.services__intro__group__texte .inner'];
	qs.forEach(function(q, i){
		// var lines = new SplitText($(el).find('.services__intro__group__titre .inner, .services__intro__group__sous__titre .inner, .services__intro__group__texte .inner'), {type:'lines'}).lines;
		var lines = new SplitText($(el).find(q), {type:'lines'}).lines;
		// var $lines = $(lines).add( $(el).find('.home__titreb') );
		var $lines = $(lines);
		
		var wrapmask = $lines.wrapmask({cn:'ovh rel'});
		tl.fadeUp( wrapmask.childs, {
			yOrigin: '101%',
			duration: 1.5,
			stagger: 0.05,
		}, i * 0.1 )
	})
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-services-slideshow', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	var $els = $(el).find('.services__slideshow__group__slideshow__video').onlyVisible();
	var $center = $els.eq( Math.floor($els.length / 2) );
	var $centerBbox = $center.bbox();

	console.log('$centerBbox', $centerBbox);
	console.log('$els.length', $els.length);

	$els.each(function(i, el){
		// animate from center position
		var bbox = $(el).bbox();
		console.log('bbox', bbox);

		var decal = $centerBbox.left - bbox.left;

		tl.from( el, {
			x: decal,
			// opacity: 0,
			// y: '30rem',
			duration: 0.8,
		}, i * 0.01)
	});

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-services-slideshowo', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var tlb = new TimelineMax({paused : true});

	var $els = $(el).find('.services__slideshow__group__slideshow__video').onlyVisible();
	var $center = $els.eq( Math.floor($els.length / 2) );
	var $centerBbox = $center.bbox();

	console.log('$centerBbox', $centerBbox);
	console.log('$els.length', $els.length);

	$els.each(function(i, el){
		// animate from center position
		var bbox = $(el).bbox();
		console.log('bbox', bbox);

		var decal = $centerBbox.left - bbox.left;

		tlb.from( el, {
			x: decal,
			// opacity: 0,
			// y: '30rem',
			ease: 'none',
			duration: Math.abs(decal),
		}, i * 0.01)
	});

	tl.to( tlb, {
		progress: 1,
		ease: 'power2.out',
		duration: 1,
	} )

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-lines-mask', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
	var $lines = $(lines);
	
	var wrapmask = $lines.wrapmask({cn:'ovh rel'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( wrapmask.childs, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.2,
	})

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-window', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});

	tl.from( $(el).find('.about__instagram__group__visuels__item__inner'), {
		scale: 1/1.5,
		duration: 0.7,
		stagger: 0.2,
	}, 0);

	tl.from( $(el).find('.about__instagram__group__visuels__item__inner__inner'), {
		scale: 1.5,
		duration: 0.7,
		stagger: 0.2,
	}, 0);

	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-pf-projet-intro', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fromTo( $(el).find('.projetspost__intro__group__video'), {
		scale: 1.3,
		opacity: 0
	}, {
		scale: 1.001,
		duration: 1.5,
		opacity: 1
	});
	var lines = new SplitText($(el).find('.projetspost__intro__txts__inner .inner'), {type:'lines'}).lines;
	var $lines = $(lines);
	
	var wrapmask = $lines.wrapmask({cn:'ovh rel'});
	// tl.to( wrapmask.childs, {
	// 	duration: 1,
	// 	y: '100%',
	// 	ease: Power2.easeInOut
	// }, 0 )
	tl.fadeUp( wrapmask.childs, {
		yOrigin: '101%',
		duration: 1.5,
		stagger: 0.2,
	}, 0.5 )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-bloc-head', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.title, .nb'), {
		xOrigin: '-25rem',
		yOrigin: 0,
		stagger: 0.1,
	}, 0.2 );
	tl.from( $(el).find('.line'), {
		duration: 0.9,
		scaleX: 0,
		// opacity: 0,
		transformOrigin: '0% 50%',
	}, 0);
	$(el).find('.line').addClass('wc');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-statement', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// el.find('.home__contact__group__contacts__item').each(function(i, el){
		tl.fadeUp( $(el).find('.reveal-fadeup'), {
			xOrigin: '-25rem',
			yOrigin: 0,
			stagger: 0.1,
		}, 0.2 );
		tl.from( $(el).find('.home__statement__group__textes__line'), {
			duration: 0.9,
			scaleY: 0,
			// opacity: 0,
			transformOrigin: '50% 0%',
		}, 0);
		$(el).find('.home__statement__group__textes__line').addClass('wc');
	// });
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-team', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.home__team__group__team__item'), {
		xOrigin: '-25rem',
		yOrigin: 0,
		stagger: 0.1,
	}, 0.2 );
	tl.from( $(el).find('.home__team__team__line'), {
		duration: 0.9,
		scaleY: 0,
		// opacity: 0,
		transformOrigin: '50% 0%',
	}, 0);
	$(el).find('.home__team__team__line').addClass('wc');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-contact', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	el.find('.home__contact__group__contacts__item').each(function(i, el){
		tl.fadeUp( $(el).find('.home__contact__line'), {
			xOrigin: '-25rem',
			yOrigin: 0,
			stagger: 0.1,
		}, 0.2 + ( i * 0.2 ) );
		tl.from( $(el).find('.home__contact__group__contacts__item__line'), {
			duration: 0.9,
			scaleY: 0,
			// opacity: 0,
			transformOrigin: '50% 0%',
		}, 0 + ( i * 0.2 ));
		$(el).find('.home__contact__group__contacts__item__line').addClass('wc');
	});
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-contact-xs', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// el.find('.home__contact__group__contacts__item').each(function(i, el){
		tl.fadeUp( $(el).find('.home__contact__line'), {
			xOrigin: '-25rem',
			yOrigin: 0,
			stagger: 0.1,
		}, 0.2 );
		tl.from( $(el).find('.home__contact__group__contacts__item__line'), {
			duration: 0.9,
			scaleY: 0,
			// opacity: 0,
			transformOrigin: '50% 0%',
		}, 0);
		$(el).find('.home__contact__group__contacts__item__line').addClass('wc');
	// });
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-gallery-img-xs', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.deroul( $(el).find('.home__gallery__group__galleries__gallery__item__inner'), {
		duration: 1.1,
		direction: parseInt($(el).attr('data-index'), 10) % 2 == 0 ? 'right' : 'left',
	}, 0)
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-chora-gallery-img', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var count = parseInt($(el).attr('data-count'), 10);
	if ( count == 3 ) {
		$(el).find('.home__gallery__group__galleries__gallery__item').each(function(i, el){
			tl.deroul( $(el).find('.home__gallery__group__galleries__gallery__item__inner'), {
				duration: 1.1,
				direction: i == 0 ? 'left' : 'right',
			}, i * 0.1)
		});
	}
	if ( count == 4 ) {
		$(el).find('.home__gallery__group__galleries__gallery__item').each(function(i, el){
			tl.deroul( $(el).find('.home__gallery__group__galleries__gallery__item__inner'), {
				duration: 1.1,
				direction: i == 0 ? 'top' : 'bottom',
			}, i * 0.1)
		});
	}
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-asteren-header-page', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var chars = new SplitText($(el).find('.headerpage__page__header__group__titre p'), {type:'lines,words,chars'}).chars;
	tl.fadeUp( chars, {
		xOrigin: '-15rem',
		yOrigin: 0,
		stagger: 0.03,
	} );
	tl.from( $(el).find('.headerpage__page__header__group__visuel'), {
		duration: 0.9,
		y: '20rem',
		opacity: 0,
		scale: 0.9,
		transformOrigin: '50% 10%',
	}, 0.2);
	tl.from( $(el).find('.headerpage__page__header__group__picto'), {
		duration: 0.9,
		// y: '20rem',
		opacity: 0,
		scale: 0.8,
		transformOrigin: '50% 50%',
	}, 0.1);
	$(el).find('.headerpage__page__header__group__visuel').addClass('wc');
	$(el).find('.headerpage__page__header__group__picto').addClass('wc');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-asteren-header-page-sml', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var chars = new SplitText($(el).find('.headerpagesml__title'), {type:'lines,words,chars'}).chars;
	tl.fadeUp( chars, {
		xOrigin: '-15rem',
		yOrigin: 0,
		stagger: 0.03,
	}, 0 );
	if ( $(el).find('.headerpagesml__back').length ) {
		tl.fadeUp( $(el).find('.headerpagesml__back'), {
			xOrigin: '15rem',
			yOrigin: 0,
			stagger: 0.03,
		}, 0 );
	}
	tl.from( $(el).find('.headerpagesml__page__header__group__visuel__wrap__svg'), {
		duration: 0.9,
		// y: '20rem',
		opacity: 0,
		scale: 0.8,
		transformOrigin: '50% 50%',
	}, 0.1);
	$(el).find('.headerpagesml__page__header__group__visuel__wrap__svg').addClass('wc');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ra-lines', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText(el.find('.inner'), {type:'lines'}).lines;
	tl.fadeUp( lines, {

	} );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ra-headerbloc', '.scroll-reveal', function(evt){
	if ( MQ(-767) ){
		return;
	}
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fromTo( $(el).find('.ra__headerbloc__titre__line__inner'), {
		scaleX: 0.5,
		opacity: 0,
	}, {
		scaleX: 1,
		opacity: 1,
		duration: 0.6,
	});
	tl.fromTo( $(el).find('.ra__headerbloc__cta'), {
		opacity: 0,
		x: '-30rem',
	}, {
		opacity: 1,
		x: '0rem',
		duration: 1.15
	}, 0.15);
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-headerpageold', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__header__section__bg');
	console.log('bg', bg);
	tl.from( bg, {
		y: '-101%',
		duration: 1.5,
		ease: 'power2.out',
	}, 0);
	tl.from( el.find('.headerpage__page__left'), {
		x: '-86rem',
		duration: 0.9,
		opacity: 0,
	}, 0.7 );
	tl.from( el.find('.headerpage__page__right'), {
		x: '86rem',
		duration: 0.9,
		opacity: 0,
	}, 0.8 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-headerpage', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__header__section__bg');
	console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.from( el.find('.headerpage__page__left'), {
		x: '-40rem',
		duration: 0.4,
		opacity: 0,
	}, 0.1 );
	tl.from( el.find('.headerpage__page__right'), {
		x: '40rem',
		duration: 0.4,
		opacity: 0,
	}, 0.2 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-home-intro', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__intro__section__bg');
	console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.fadeUp( el.find('.home__intro__titre, .home__intro__texte, .home__intro__cta'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0.1 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-home-expertises', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__intro__section__bg');
	console.log('bg', bg);
	tl.fadeUp( el.find('.home__expertises__titre, .home__expertises__texte'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0 );
	el.find('.home__expertises__liste__item, .home__expertises__liste__item__line').each(function(i, el){
		if ( $(el).hasClass('home__expertises__liste__item__line') ){
			tl.from( el, {
				opacity: 0,
				scale: 0.5,
				transformOrigin: '0% 50%',
				duration: 0.7
			}, 0.2 + i * 0.05 )
		}
		else {
			tl.from( el, {
				x: '-50rem',
				opacity: 0,
				duration: 0.7,
			}, 0.2 + i * 0.05 )
		}
	});
	tl.fadeUp( el.find('.home__expertises__cta'), {
		duration: 0.7
	}, '-=0.6' )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-casestudyslide', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.casestudy__slide__section__bg');
	// console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.fadeUp( el.find('.casestudy__slide__title'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0.1 );
	tl.from( el.find('.casestudy__slide'), {
		opacity: 0,
		duration: 0.7,
		ease: 'none',
	}, 0.2 );
	tl.from( el.find('.swiper-container'), {
		x: '200rem',
		duration: 0.7,
	}, 0.2 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-casestudy-detail-footer', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.casestudy__detail__footer__bg');
	// console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.from( el.find('.casestudypost__bloc__head'), {
		opacity: 0,
		x: '-100rem',
		duration: 0.9,
		ease: 'power2.out',
	}, 0.2 );
	tl.from( el.find('.casestudypost__bloc__body'), {
		opacity: 0,
		x: '100rem',
		duration: 0.9,
		ease: 'power2.out',
	}, 0.2 );
	tl.fadeUp( el.find('.casestudy__detail__contact__cta__wrap'), {

	}, 0.3 );
	setTimeout(function() {
		tl.play();
	}, 5);
});


$('body').on('reveal-ec-casestudy-detail-visu', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( el.find('img'), {
		duration: 1,
		stagger: 0.09,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-newsslide', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.news__slide__section__bg');
	console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.fadeUp( el.find('.news__slide__title'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0.1 );
	tl.from( el.find('.news__slide'), {
		opacity: 0,
		duration: 0.7,
		ease: 'none',
	}, 0.2 );
	tl.from( el.find('.swiper-container'), {
		x: '200rem',
		duration: 0.7,
	}, 0.2 );
	tl.fadeUp( el.find('.news__slide__cta'), {
		duration: 0.7
	}, '-=0.6' );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-cabinet-contenu', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( el.find('.cabinet__contenu__visuel, .cabinet__contenu__titre, .cabinet__contenu__blocs__item'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-expertises', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__intro__section__bg');
	console.log('bg', bg);
	tl.fadeUp( el.find('.expertises__titre'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0 );
	el.find('.expertises__blocs__item__line, .expertises__blocs__item__head__inner').each(function(i, el){
		if ( $(el).hasClass('expertises__blocs__item__line') ){
			tl.from( el, {
				opacity: 0,
				scale: 0.5,
				transformOrigin: '0% 50%',
				duration: 0.7
			}, 0.2 + i * 0.05 )
		}
		else {
			tl.from( el, {
				x: '-50rem',
				opacity: 0,
				duration: 0.7,
			}, 0.2 + i * 0.05 )
		}
	});
	tl.fadeUp( el.find('.home__expertises__cta'), {
		duration: 0.7
	}, '-=0.6' )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-secteurs', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__intro__section__bg');
	console.log('bg', bg);
	tl.fadeUp( el.find('.expertises__titre'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0 );
	tl.from( el.find('.expertises__secteurs__item__item'), {
		opacity: 0,
		scale: 1.15,
		duration: 0.7,
		stagger: 0.09
	}, 0.1 )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-ec-contact', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.contact__formulaire__section__bg');
	console.log('bg', bg);
	tl.from( bg, {
		opacity: 0,
		duration: 0.4,
		ease: 'none',
	}, 0);
	tl.fadeUp( el.find('.contact__formulaire__titre'), {
		duration: 0.7,
		stagger: 0.09,
	}, 0.1 );
	tl.from( el.find('.contact__formulaire__cols'), {
		opacity: 0,
		duration: 0.7,
		ease: 'none',
	}, 0.2 );
	setTimeout(function() {
		tl.play();
	}, 5);
});



$('body').on('reveal-ec-news', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var delay = 0;
	var scrollTop = window.scrollY;
	var headerHeight = $('.header').height();
	var wh = $(window).height();
	scrollTop += headerHeight;
	wh -= headerHeight;
	var titleBb = el.find('.news__titre__page').bbox();
	if ( titleBb.bottom >= scrollTop ){
		tl.fadeUp( el.find('.news__titre__page'), {
			duration: 0.7,
			stagger: 0.09,
		}, 0 );
		delay += 0.1;
	}
	console.log('ec-news-debug nb ', scrollTop, headerHeight, wh);
	var els = el.find('.news__items__line, .newspost__thumbnail__wrap').get();
	// var els = el.find('.newspost__thumbnail__wrap').get();
	var ii = 0;
	for(var i=0,j=els.length;i<j;i++){
		var el = els[i];
		var elBb = $(el).bbox( $(el).closest('.news__section') );
		console.log('ec-news-debug nb ', i, ii, '|', elBb.top, '>', scrollTop + wh, '|', elBb.bottom, '<', scrollTop);
		if ( !$(el).is(':visible') ){
			console.log('ec-news-debug is not visible');
			continue;
		}
		if ( elBb.bottom < scrollTop ){ // element before the window
			console.log('ec-news-debug element before the window');
			continue;
		}
		if ( elBb.top > scrollTop + wh ){ // element after the window
			console.log('ec-news-debug element after the window');
			if ( $(el).hasClass('news__items__line') ){
				$(el).addClass('scroll-reveal scroll-reveal-ec-line');
				$(el).attr('data-reveal', 'css');
			}
			else {
				$(el).addClass('scroll-reveal reveal-fadeup');
				$(el).attr('data-reveal', 'css');
			}
			continue;
		}
		if ( $(el).hasClass('news__items__line') ){
			tl.from( el, {
				opacity: 0,
				scale: 0.5,
				transformOrigin: '0% 50%',
				duration: 0.7
			}, delay + ii * 0.05 )
		}
		else {
			tl.fadeUp( el, {
				duration: 0.7,
			}, delay + ii * 0.05 )
		}
		ii++;
	}
	$(window).trigger('addScrollRevealElements');
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-valpaco-home-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.home__header__visuel__bg');
	console.log('bg', bg);
	tl.to( bg, {
		scale: 1.001,
		transformOrigin: '50% 50%',
		ease: 'power2.out',
		duration: 1.7
	});
	var lines = $(el).find('.home__header__texte .inner');
	lines = new SplitText(lines, {type:'lines'}).lines;
	var cta = $(el).find('.home__header__cta').get(0);
	lines.push(cta);
	tl.set( $(el).find('.home__header__content'), {opacity:1}, 0.1);
	tl.fadeUp( lines, {}, 0.25 );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-valpaco-headerpage', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var bg = $(el).find('.headerpage__section__bg');
	tl.to( bg, {
		scale: 1.001,
		transformOrigin: '50% 50%',
		ease: 'power2.out',
		duration: 1.7
	});
	var chars = $(el).find('.headerpage__page__header__titre__page .inner');
	chars = new SplitText(chars, {type:'lines,words,chars'}).chars;
	var stagger = 0.015;
	var duration = 1.5;
	tl.set( $(el).find('.headerpage__page__header'), {opacity:1}, 0.1);
	tl.from( chars, {
		opacity: 0,
		stagger: stagger,
		duration: function(i, el){
			console.log('debugstepfunction', i, el);
			var iInverse = chars.length - i;
			return duration + iInverse * stagger;
		}
	}, 0.25 )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-valpaco-about-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var chars = $(el).find('.about__header__titre__page .inner');
	chars = new SplitText(chars, {type:'lines,words,chars'}).chars;
	var stagger = 0.015;
	var duration = 1.5;
	tl.set( $(el).find('.about__header__titre__page'), {opacity:1}, 0);
	tl.from( chars, {
		opacity: 0,
		stagger: stagger,
		duration: function(i, el){
			console.log('debugstepfunction', i, el);
			var iInverse = chars.length - i;
			return duration + iInverse * stagger;
		}
	}, 0.05 )
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-valpaco-blocpageb', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var blocs = $(el).find('.blocpageb__bloc__right, .blocpageb__bloc__left').get();
	blocs.sort(function(a, b) {
	  return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
	});
	if ( MQ(-767) ){
		blocs = $(el).find('.blocpageb__bloc__cols');
	}
	tl.fadeUp( blocs, {} );
	setTimeout(function() {
		tl.play();
	}, 5);
});

$('body').on('reveal-cultes-headerpage', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.headerpage__page__header__visuel img'), {
		opacity: 0,
		transformOrigin: '50% 50%',
		ease: 'power2.out',
		duration: 1.7
	});
	tl.from( $(el).find('.headerpage__page__header__visuel img'), {
		scale: 1.05,
		transformOrigin: '50% 50%',
		ease: 'power2.out',
		duration: 2.1
	}, 0);
	var lines = new SplitText($(el).find('.headerpage__page__line'), {type:'lines'}).lines;
	tl.fadeUp( lines, {
		duration: 1.15,
		stagger: 0.11
	}, 0.5 );
	tl.fadeUp( $(el).find('.headerpage__arrow__wrap'), {
		yOrigin: '-25%',
		duration: 1.2
	}, '-=1.1' );
	tl.play();
});

$('body').on('reveal-cultes-home-services', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.servicepost__titre__wrap, .home__services__cta'), {
		yOrigin: '30rem',
		// xOrigin: '-50rem',
		stagger: 0.01
	} )
	tl.play();
});

$('body').on('reveal-cultes-slide', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// $(el).find('[data-js="slideshow-items"]').slick('slickGoTo', 0);
	$(el).find('.slick-current').find('.slide__txt__bloc ').addClass('wc');
	tl.fromTo( $(el).find('.slick-current, .is-active').find('.slide__visu__bloc__inner'), {
		scale: 1.07
		// xOrigin: '-50rem',
	}, {
		scale: 1.01,
		duration: 1.2,
	});
	tl.fromTo( $(el).find('.slick-current').find('.slide__txt__bloc '), {
		y: '30rem',
		opacity: 0,
		// xOrigin: '-50rem',
	}, {
		duration: 1.2,
		opacity: 1,
		y: '0rem',
		stagger: 0.1
	}, 0);
	tl.addLabel('partB');
	tl.fromTo( $(el).find('.slideshow__arrow'), {
		duration: 1.2,
		opacity: 0,
		x: function(i, el){
			console.log('igsap', i);
			var offset = '50rem';
			return ( i % 2 == 1 ? '-' : '' ) + offset
		}
	}, {
		opacity: 1,
		stagger: 0.1,
		x: '0rem'
	}, '-=0.5');
	$(el).find('.home__travailler__slide__items__navs').each(function(i, elNavs){
		tl.fromTo( $(elNavs).find('.inner'), {
			opacity: 0
		}, {
			opacity: 1,
			duration: 1.2,
			stagger: 0.07
		}, 0 )
	});
	$(el).find('.home__services__slide__items__navs__wrap').each(function(i, elNavs){
		tl.fromTo( $(elNavs).find('.servicepost__titre__wrap, .home__services__cta'), {
			opacity: 0,
			x: '-50rem',
			// y: '30rem'
		}, {
			// opacity: 1,
			x: 0,
			y: 0,
			duration: 0.9,
			stagger: 0.01
		}, 0.05 )
	});
	$(el).find('.services__methode__slide__items__navs__wrap').each(function(i, elNavs){
		tl.fromTo( $(elNavs).find('.services__methode__slide__items__navs__arrow__wrap, .inner'), {
			opacity: 0,
			y: '30rem'
		}, {
			opacity: 1,
			y: 0,
			duration: 0.9,
			stagger: 0.1
		}, 0.05 )
	});
	$(el).find('.home__services__slide__items__navs__wrap').each(function(i, elNavs){
		tl.fromTo( $(elNavs).find('.servicepost__titre__wrap'), {
			opacity: 0,
			x: '-50rem'
		}, {
			opacity: 1,
			x: 0,
			duration: 0.9,
			stagger: 0.01
		}, 0.05 )
	});
	tl.play();
});

$('body').on('reveal-cultes-contraintes-item', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.services__contraintes__item__line'), {
		scaleX: 0,
		transformOrigin: '0% 50%',
		duration: 1.3
	})
	tl.fadeUp( $(el).find('.services__contraintes__titre, .services__contraintes__texte'), {
		duration: 1.1,
		stagger: 0.1
	}, 0.1 )
	tl.play();
});

$('body').on('reveal-cultes-news-intro', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// var lines = new SplitText($(el).find('.news__texte'), {type:'lines'}).lines;
	var els = $(el).find('.news__titre, .news__line, .news__texte').get();
	// els = els.concat( lines );
	tl.fadeUp( els );
	tl.play();
});

$('body').on('reveal-cultes-contact-titre', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
	tl.fadeUp( lines );
	tl.play();
});

$('body').on('reveal-cultes-contact-form', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText($(el).find('.contact__formulaire__titre'), {type:'lines'}).lines;
	tl.fadeUp( lines, {
		yOrigin: 0,
		xOrigin: '-50rem'
	} );
	tl.fadeUp( $(el).find('.contact__formulaire'), {}, 0.15 )
	tl.play();
});

$('body').on('reveal-archipel-career-item', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.careers__item__line'), {
		scaleX: 0,
		transformOrigin: '0% 50%',
		duration: 1.3
	})
	tl.fadeUp( $(el).find('.careers__item__el'), {
		duration: 1.1,
		stagger: 0.1
	}, 0.1 )
	tl.play();
});

$('body').on('reveal-archipel-careers-slideshow', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.careers__slideshow__items img'), {
		opacity: 0,
		duration: 0.5
	} )
	tl.fadeUp( $(el).find('.careers__slideshow__items__navs'), {
		duration: 1.1,
		stagger: 0.07
	}, 0.1 )
	tl.play();
});

$('body').on('reveal-archipel-news-big', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.actu__mea__big__item__visuel img'), {
		opacity: 0,
		scale: 0.9,
		duration: 1.1
	} )
	tl.fadeUp( $(el).find('.actu__mea__big__item__txts__wrap'), {
		duration: 1.1
	}, 0.1 )
	tl.play();
});

$('body').on('reveal-archipel-team', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	if ( MQ(768) ) {
		var lines = new SplitText($(el).find('.team__titre__page .inner'), {type:'lines'}).lines;
		tl.fadeUp( lines, {
			yOrigin: 0,
			xOrigin: '-30rem'
		})
		tl.fadeUp( $('.projets__filters__bloc'), {
			yOrigin: 0,
			xOrigin: '30rem',
			stagger: 0.075
		}, 0.1)
		var els = $(el).find('.teampost__item__content').get();
		var max = Math.min(els.length, 12);
		els = els.slice(0, max);
		tl.fadeUp( els, {
			stagger: 0.075,
			duration: 1.3
		}, 0.2 );
	}
	else {
		var elsTop = $(el).find('.team__titre__page .inner, .projets__filters__bloc').get();
		var els = $(el).find('.teampost__item__content').get();
		var max = Math.min(els.length, 3);
		els = els.slice(0, max);
		elsTop.push(...els);
		tl.fadeUp( elsTop, {
			stagger: 0.075,
			duration: 1.3
		}, 0 );
	}
	tl.play();
});

$('body').on('reveal-archipel-about-corporate', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText($(el).find('.about__corporate__titre .inner'), {type:'lines'}).lines;
	tl.fadeUp( lines, {
		yOrigin: 0,
		xOrigin: '-30rem'
	})
	tl.fadeUp( $('.about__corporate__item__titre__wrap .inner'), {
		yOrigin: 0,
		xOrigin: '-50rem'
	}, 0.1)
	tl.from( $('.about__corporate__titre__line'), {
		scaleX: 0,
		transformOrigin: '0% 50%',
		stagger: 0.1
	}, 0.2)
	tl.deroul( $('.about__corporate__visuel__inner'), {
		duration: 1.1,
		direction: 'right'
	}, 0.25)
	tl.from( $('.about__corporate__rect__wrap'), {
		scale: 0.8,
		opacity: 0
	}, 0 )
	tl.play();
});

$('body').on('reveal-archipel-about-why', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var tlrect = new TimelineMax({paused : true});
	tlrect.set( $(el).find('.about__why__rect__logo__inner'), {
		scaleX: 0.05,
		scaleY: 0.05,
		// duration: 0.9,
		opacity: 0,
		ease: 'none'
	}, 0);
	tlrect.to( $(el).find('.about__why__rect__logo__inner'), {
		duration: 0.5,
		opacity: 1,
		ease: 'none'
	}, 0);
	tlrect.to( $(el).find('.about__why__rect__logo__inner'), {
		duration: 0.5,
		scaleX: 1.001,
		ease: 'none'
	}, 0);
	tlrect.to( $(el).find('.about__why__rect__logo__inner'), {
		duration: 0.5,
		scaleY: 1.001,
		ease: 'none'
	}, 0.35);
	tl.fromTo( tlrect, {
		progress: 0
	}, {
		progress: 1,
		duration: 1,
		ease: 'power2.inOut'
	} )
	if ( MQ(768) ) {
		tl.fadeUp( $(el).find('.about__why__titre, .about__why__phonetique__wrap, .about__why__texte'), {
			yOrigin: 0,
			xOrigin: '-50rem',
		}, 0.1)
	}
	else {
		tl.fadeUp( $(el).find('.about__why__titre, .about__why__phonetique__wrap, .about__why__texte'), {
			yOrigin: '50rem',
		}, 0.1)
	}
	tl.play();
});

$('body').on('reveal-archipel-about-chiffres', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	$(el).find('.about__chiffres__item').each(function(i, el){
		tl.from( $(el).find('.about__chiffres__visuel'), {
			scale: 0.7,
			opacity: 0,
			duration: 1
		}, i * 0.1 );
		var wrapmask = $(el).find('.about__chiffres__texte__1, .about__chiffres__chiffre, .about__chiffres__texte__2').wrapmask({cn:'ovh rel',mask:'mask'});
		// tl.to( wrapmask.childs, {
		// 	duration: 1,
		// 	y: '100%',
		// 	ease: Power2.easeInOut
		// }, 0 )
		tl.fadeUp( wrapmask.childs, {
			yOrigin: '101%',
		}, i * 0.1 + 0.1 )
	});
	tl.play();
});

$('body').on('reveal-archipel-home-news', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.actu__mea__item__content__item'), {

	} )
	tl.play();
});

$('body').on('reveal-archipel-titre', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var lines = new SplitText($(el).find('.inner'), {type:'lines'}).lines;
	if ( MQ(768) ) {
		tl.fadeUp( lines, {
			yOrigin: 0,
			xOrigin: '-30rem'
		}, 0.1)
	}
	else {
		tl.fadeUp( lines, {
			yOrigin: '50rem'
		}, 0.1)
	}
	tl.play();
});

$('body').on('reveal-archipel-map', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var cities = shuffle( $(el).find('.bloc__map__map .map__city') );
	tl.fromTo( cities, {
		fill: '#fff',
		duration: 0.95,
		stagger: 0.01
	}, {
		fill: '#000',
		duration: 0.95,
		stagger: 0.01
	});
	var lines = new SplitText($(el).find('.bloc__map__titre .inner'), {type:'lines'}).lines;
	tl.fadeUp( lines, {
		yOrigin: 0,
		xOrigin: '-30rem'
	}, 0.1)
	tl.play();
});

$('body').on('reveal-expertise-item', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	if ( MQ(768) ){
		tl.from( $(el).find('.home__expertises__item__bg'), {
			opacity: 0,
			scaleX: 0,
			duration: 0.6,
			transformOrigin: '0% 50%'
		});
		tl.fadeUp( $(el).find('.home__expertises__item__titre, .home__expertises__item__texte'), {
			yOrigin: '30rem',
			duration: 0.8,
			stagger: 0.2
		}, 0.2);
	}
	else {
		tl.fadeUp( $(el), {
			yOrigin: '50rem'
		}, 0);
	}
	tl.play();
});

$('body').on('reveal-archipel-bloc-with-hover', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var start = 0;
	if ( $(el).find('.bloc__with__hover__bg').length ){
		tl.from( $(el).find('.bloc__with__hover__bg'), {
			opacity: 0,
			duration: 1
		} )
		start = 0.2;
	}
	tl.fadeUp( $(el).find('.bloc__with__hover__item'), {
		yOrigin: '50rem',
		stagger: 0.1
	}, start )
	if ( $('body').hasClass('is-desktop') == false ){
		tl.to( $(el).find('.hover'), {
			className: '+=is-active',
			stagger: 0.1
		}, start + 0.2 )
	}
	tl.play();
});

$('body').on('reveal-page-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.header__page__header__visuel'), {
		opacity: 0,
		scale: 1.03,
		duration: 0.9
	});
	tl.fadeUp( $(el).find('.header__page__txts__bloc'), {
		yOrigin: '-10rem',
		duration: 0.9,
		stagger: 0.13
	}, 0.1);
	if ( $(el).find('.header__page__map__wrap').length ){
		tl.from( $(el).find('.header__page__map__bg, .header__page__map__lines'), {
			scale: 0.95,
			opacity: 0,
			duration: 0.9
		}, 0.2);
		$(el).find('.header__page__map__cta__inner').each(function(i, cta){
			tl.from( $(cta).find('.header__page__map__cta__triangle'), {
				scale: 0.9,
				opacity: 0,
				duration: 1.4
			}, 0.3 + ( i * 0.06 ) );
			tl.from( $(cta).find('.header__page__map__cta__infos'), {
				opacity: 0,
				duration: 1.4
			}, 0.5 + ( i * 0.06 ) );
		});
		tl.from( $(el).find('.header__page__map__ctas__mobile'), {
			scale: 0.9,
			opacity: 0,
			duration: 0.9
		}, 0.3);
	}
	tl.play();
});

$('body').on('reveal-agence-nb-item', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var index = el.index('.agence__savoir__faire__blocs__item');
	// console.log('index', el.index('.agence__savoir__faire__blocs__item'));
	var tl = new TimelineMax({paused : true});
	var way = '-';
	var direction = 'left';
	if ( index % 2 === 1 ){
		way = '';
		direction = 'right';
	}
	tl.deroul( $(el).find('.agence__savoir__faire__blocs__visuel__img__inner'), {
		x: way+'100%',
		direction: direction,
		ease: Power2.easeInOut,
		duration: 0.9
	});
	tl.from( $(el).find('.agence__savoir__faire__blocs__txt'), {
		opacity: 0,
		x: way+'25rem',
		stagger: 0.15,
		duration: function(i, el){
			return 1.5 - (i*0.15);
		}
	}, 0.1 );
	tl.from( $(el).find('.agence__savoir__faire__float__rect__visu__wrap'), {
		opacity: 0, 
		duration: 0.6
	}, 0.6);
	tl.play();
});

$('body').on('reveal-pds-quote', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var linesa = new SplitText($(el).find('.agence__citation__titre .inner'), {type:'lines'}).lines;
	var linesb = new SplitText($(el).find('.agence__citation__texte .inner'), {type:'lines'}).lines;
	var combinedLines = linesa.concat(linesb);

	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.agence__citation__quote'), {
		scale: 0.9,
		duration: 1.1
	}, 0 );
	tl.fadeUp( combinedLines, {
		stagger: 0.06
	}, 0.15 );
	tl.play();
});

$('body').on('reveal-cultes-home-grid', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var els = $(el).find('.projetpost__content').get();
	$(els).addClass('wc');
	var tl = gsap.timeline({paused : true});
	tl.from(els, {
		opacity: 0,
		scale: 0.95,
		duration: 1.5,
		ease: Power2.easeOut,
		stagger: 0.07
	}, 0);
	tl.add( function(){
		$(els).removeClass('wc');
	} );
	tl.play();
});

$('body').on('reveal-grid-items', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var els = $(el).find('.projetpost__content').get();
	var max = Math.min(els.length, 9);
	// els = els.slice(0, max);
	$(els).addClass('wc');
	var tl = gsap.timeline({paused : true});
	tl.from(els, {
		opacity: 0,
		scale: 0.95,
		duration: 1.5,
		ease: Power2.easeOut,
		stagger: 0.07
	}, 0.3);
	tl.fadeUp( $(el).find('.filter__item__wrap'), {

	}, 0 );
	tl.from( $(el).find('.projets__filters__items__line'), {
		scaleX:0,
		transformOrigin: '0% 0%',
		duration: 0.9
	}, 0 )
	tl.add( function(){
		$(els).removeClass('wc');
	} );
	tl.play();
});

$('body').on('reveal-projet-detail-top', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = gsap.timeline({paused : true})
	tl.fadeUp( $(el).find('.projet__head__link, .projet__intro__titre, .projet__intro__sous__titre'), {
		stagger: 0.1
	}, 0 );
	tl.play();
});

$('body').on('reveal-mea-actus', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.blocs__mise__en__avant__actualites__section__bg'), {
		opacity: 0,
		duration: 0.3
	});
	var els = $(el).find('.blocs__mise__en__avant__actualites__actus__item').find('article');
	// alert(els.length)
	tl.from( els, {
		opacity: 0,
		scale: 0.95,
		duration: 0.9,
		stagger: 0.06
	}, 0.1);
	tl.play();
});

$('body').on('reveal-chronologie-frise-item', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.blocs__frise__blocs__item__dot'), {
		scale: 0.5,
		opacity: 0,
		duration: 0.3
	}, 0);
	tl.from( $(el).find('.blocs__frise__blocs__item__line'), {
		scaleY: 0,
		transformOrigin: '0% 0%',
		duration: 1,
		ease: 'linear:none'
	}, 0);
	var els = $(el).find('.blocs__frise__blocs__item__txts, .blocs__frise__blocs__item__media');
	els.addClass('wc');
	// alert(els.length)
	tl.from( els, {
		opacity: 0,
		scale: 0.95,
		duration: 0.9,
		stagger: 0.06
	}, 0.1);
	tl.play();
});

$('body').on('reveal-home-foot', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.bloc__socs__li, .header__language__list li'), {
		yOrigin: '30rem',
		duration: 1.15,
		stagger: 0.13
	} )
	tl.play();
});

$('body').on('reveal-add-page-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('.pageheader__visuel img'), {
		yOrigin: '50rem',
		duration: 1.15,
		stagger: 0.13
	}, 0);
	var delay = 0;
	if ( $(el).find('.pageheader__surtitre__line').length ){
		tl.from( $(el).find('.pageheader__surtitre__line').eq(0), {
			scaleX: 0,
			transformOrigin: '100% 0'
		}, {
			scaleX: 1,
			transformOrigin: '100% 0',
			duration: 1
		}, 0 );
		tl.from( $(el).find('.pageheader__surtitre__line').eq(1), {
			scaleX: 0,
			transformOrigin: '0% 0'
		}, {
			scaleX: 1,
			transformOrigin: '0% 0',
			duration: 1
		}, 0 );
		tl.fadeUp( $(el).find('.pageheader__surtitre .inner'), {
			yOrigin: '30rem',
			duration: 1.15
		} );
		delay = 0.3;
	}

	var sp = new SplitText( $(el).find('.pageheader__titre .inner'), {type:'lines,words,chars'});
	// var sp = new SplitText($(el).find('.pageheader__titre'), {type:'lines'});
	// tl.fadeUp( sp.lines, {
	tl.from( sp.chars, {
		opacity: 0,
		scale: 0.3,
		duration: 1.15,
		stagger: 0.03
	}, delay );
	tl.play();
});

$('body').on('reveal-add-pageheader', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var delay = 0;
	if ( $(el).find('.pageheader__surtitre__line').length ){
		tl.from( $(el).find('.pageheader__surtitre__line').eq(0), {
			scaleX: 0,
			transformOrigin: '100% 0'
		}, {
			scaleX: 1,
			transformOrigin: '100% 0',
			duration: 1
		}, 0 );
		tl.from( $(el).find('.pageheader__surtitre__line').eq(1), {
			scaleX: 0,
			transformOrigin: '0% 0'
		}, {
			scaleX: 1,
			transformOrigin: '0% 0',
			duration: 1
		}, 0 );
		tl.fadeUp( $(el).find('.pageheader__surtitre .inner'), {
			yOrigin: '30rem',
			duration: 1.15
		} );
		delay = 0.3;
	}

	var sp = new SplitText( $(el).find('.pageheader__titre .inner'), {type:'lines,words,chars'});
	// var sp = new SplitText($(el).find('.pageheader__titre'), {type:'lines'});
	// tl.fadeUp( sp.lines, {
	tl.from( sp.chars, {
		opacity: 0,
		scale: 0.3,
		duration: 1.15,
		stagger: 0.03
	}, delay );
	tl.play();
});

$('body').on('reveal-works-logos', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var pos = $(el).attr('data-pos');
	var tl = new TimelineMax({paused : true});
	var delay = 0;
	var way = pos == '1' ? '+' : '-';
	var tfo = pos == '1' ? '100% 0' : '0 0';
	tl.fadeUp( $(el).find('.works__footer__blocs__titre .inner'), {
		xOrigin: way+'30rem',
		yOrigin: 0,
		duration: 1.15
	}, 0);
	tl.from( $(el).find('.works__footer__blocs__titre__line'), {
		scaleX: 0,
		duration: 1.3,
		transformOrigin: tfo
	}, 0);
	var slidesItems = $(el).find('.slideshow__item.slick-active').get();
	if ( pos == '1' ){
		slidesItems.reverse();
	}
	tl.from( slidesItems, {
		scale: 0.8,
		opacity: 0,
		stagger: 0.1,
		duration: 1.3
	}, 0);
	tl.from( $(el).find('.slideshow__arrow .svg__wrap'), {
		opacity: 0,
		x: '-30rem',
		duration: 1.1
	}, 0.5 );
	tl.play();
});

$('body').on('reveal-add-cols', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('[data-col="line"]'), {
		scaleY: 0,
		duration: 1.3,
		transformOrigin: '0 0'
	}, 0);
	// var sa = new SplitText($(el).find('[data-col="left"]'), {type:'lines,words'}).lines;
	tl.fadeUp( $(el).find('[data-col="left"]'), {
		xOrigin: '30rem',
		yOrigin: 0,
		duration: 1.15,
		stagger: 0.03
	}, 0.2);
	// var sb = new SplitText($(el).find('[data-col="right"]'), {type:'lines,words'}).lines;
	tl.fadeUp( $(el).find('[data-col="right"]'), {
		xOrigin: '-30rem',
		yOrigin: 0,
		duration: 1.15,
		stagger: 0.08
	}, 0.3);
	tl.play();
});

$('body').on('reveal-add-logos', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.agence__prix__frise__item'), {
		opacity: 0,
		y: function(index){
			var ways = [0, '-30rem', 0, '30rem'];
			return ways[index%4];
		},
		ease: 'power2.Out',
		duration: 1.15,
		stagger: 0.01
	} );
	tl.play();
});

$('body').on('reveal-add-people-slide', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var slidesItems = $(el).find('.slideshow__item.slick-active').get();
	tl.from( slidesItems, {
		scale: 0.8,
		opacity: 0,
		stagger: 0.1,
		duration: 1.3
	}, 0);
	tl.from( $(el).find('.slideshow__arrow .svg__wrap'), {
		opacity: 0,
		duration: 1.1
	}, 0.5 );
	tl.play();
});

$('body').on('reveal-add-partners-logos', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var slidesItems = $(el).find('.savoirfaire__footer__logos__item').get();
	tl.from( slidesItems, {
		scale: 0.8,
		opacity: 0,
		stagger: 0.1,
		duration: 1.3
	}, 0);
	tl.play();
});

$('body').on('reveal-add-annonce-cols', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('[data-col="line"]'), {
		scaleY: 0,
		duration: 1.3,
		transformOrigin: '0 0'
	}, 0);
	var wayA = '+';
	var wayB = '-';
	var decalA = 0.1;
	var decalB = 0.2;
	if ( isLeft($(el).find('.annonce__type')) ){
		wayA = '-';
		wayB = '+';
		decalA = 0.2;
		decalB = 0.1;
	}
	console.log( 'aaa', $(el).find('.annonce__item__picto').length );
	tl.fadeUp( $(el).find('.annonce__item__picto'), {
		xOrigin: wayA+'30rem',
		yOrigin: 0,
		duration: 1.15,
		stagger: 0.1
	}, decalA);
	tl.fadeUp( $(el).find('.right > div'), {
		xOrigin: wayB+'30rem',
		yOrigin: 0,
		duration: 1.15,
		stagger: 0.1
	}, decalB);
	tl.play();
});


$('body').on('reveal-add-projet-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var delay = 0;
	if ( $(el).find('.projet__header__client').length ){
		tl.from( $(el).find('.projet__header__client__line').eq(0), {
			scaleX: 0,
			transformOrigin: '100% 0'
		}, {
			scaleX: 1,
			transformOrigin: '100% 0',
			duration: 1.5
		}, 0 );
		tl.from( $(el).find('.projet__header__client__line').eq(1), {
			scaleX: 0,
			transformOrigin: '0% 0'
		}, {
			scaleX: 1,
			transformOrigin: '0% 0',
			duration: 1.5
		}, 0 );
		tl.fadeUp( $(el).find('.projet__header__client .inner'), {
			yOrigin: '30rem',
			duration: 1.5
		}, 0.1 );
		delay = 0.2;
	}

	// var sp = new SplitText(el, {type:'lines,words,chars'});
	var sp = new SplitText($(el).find('.projet__header__title'), {type:'lines'});
	tl.fadeUp( sp.lines, {
		yOrigin: '30rem',
		duration: 1.5
	}, delay );
	tl.fadeUp( $(el).find('.projet__header__footer > div'), {
		yOrigin: '30rem',
		duration: 1.5
	}, delay + 0.3 );
	tl.play();
});


$('body').on('reveal-add-projet-case-titre', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.projet__case__titre__line').eq(0), {
		scaleX: 0,
		transformOrigin: '100% 0'
	}, {
		scaleX: 1,
		transformOrigin: '100% 0',
		duration: 1.5
	}, 0 );
	tl.from( $(el).find('.projet__case__titre__line').eq(1), {
		scaleX: 0,
		transformOrigin: '0% 0'
	}, {
		scaleX: 1,
		transformOrigin: '0% 0',
		duration: 1.5
	}, 0 );
	tl.fadeUp( $(el).find('.inner'), {
		yOrigin: '30rem',
		duration: 1.5
	}, 0.1 );
	tl.play();
});

$('body').on('reveal-add-title-with-line', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fadeUp( $(el).find('[data-js="title"]'), {
		xOrigin: '-30rem',
		yOrigin: 0,
		duration: 1.15
	}, 0);
	tl.from( $(el).find('[data-js="line"]'), {
		scaleX: 0,
		duration: 1.3,
		transformOrigin: '0 0'
	}, 0);
	tl.play();
});









$('body').on('reveal-slideshow-multi-items', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var slide_items = [];
	var items = $(el).find('.insta__bloc__img');
	var odd = 5;
	if ( MQ(-768) ) {
		odd = 2;
	}
	// var total = Math.ceil(items.length / odd);
	for (var i = 0; i < items.length; i++) {
		if ( !slide_items[i % odd] ){
			slide_items[i % odd] = [];
		}
		slide_items[i % odd].push(items.get(i));
	}

	var delay = 0;
	for (var i = 0; i < slide_items.length; i++) {
		tl.fadeUp( slide_items[i], {
			yOrigin: '30rem',
			stagger: 0.00,
			duration: 1.15
		}, delay);
		delay += 0.1;
	}
	slide_items = [];
	slide_items.push( $(el).find('.insta__arrows').get() );
	// slide_items.push( $(el).find('.insta__arrow.prev').get() );
	// slide_items.push( $(el).find('.insta__arrow.next').get() );
	// slide_items.push( $(el).find('[data-js="slick-nav-items"]').get() );
	console.log('slide_items', slide_items);
	tl.fadeUp( slide_items, {
		yOrigin: '30rem',
		stagger: 0.10,
		duration: 1.15
	}, delay);
	tl.call(function(){
		$(el).find('[data-js="slideshow-items"]').slick('slickPlay');
	})
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-home-head', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fromTo($(el), 0.1, {
		opacity: 0,
	}, {
		opacity: 1
	}, 0);
	tl.to($(el).find('.home__video__content__mask'), 1.5, {
		y:'101%',
		ease: Power2.easeInOut
	}, 0.1);
	// tl.deroul( $(el), {
	// 	y: '-100%',
	// 	ease: Power2.easeInOut,
	// 	duration: 15.5
	// }, 0.5);
	setTimeout(function() {
		tl.play();
	}, 25);
});

$('body').on('reveal-page-head', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.fromTo($(el), 0.1, {
		opacity: 0,
	}, {
		opacity: 1
	}, 0);
	tl.deroul( $(el).find('.page__header__content'), {
		y: '-100%',
		ease: Power2.easeInOut,
		duration: 1.1
	}, 0);
	setTimeout(function() {
		tl.play();
	}, 25);
	
});

$('body').on('reveal-bloc-cols', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// if ( MQ(768) ) {
	// 	$(el).find('.sre').each(function(i, el){
	// 		el = $(el);
	// 		var direction = 'right';
	// 		var offset = '-30rem';
	// 		if ( isLeft(el) ){
	// 			direction = 'left';
	// 			offset = '30rem';
	// 		}
	// 		if ( el.find('img').length || el.find('video').length ) {
	// 			tl.deroul( $(el), {
	// 				ease: Power2.easeInOut,
	// 				duration: 1.1,
	// 				direction: direction
	// 			}, i * 0.1);
	// 		}
	// 		else {
	// 			tl.from( el, {
	// 				ease: Power2.easeOut,
	// 				opacity: 0,
	// 				x: offset,
	// 				duration: 1.1,
	// 				stagger: 0.1
	// 			}, i * 0.1);
	// 		}
	// 	});
	// }
	// else {
		// var els = $(el).find('.about__blocs__visuel').add($(el).find('.about__blocs__txts').children());
		// var els = $(el).find('.about__blocs__visuel').get().concat($(el).find('.about__blocs__txts').children().get());
		// tl.from( $(el).find('.sre'), {
		// 	ease: Power2.easeOut,
		// 	opacity: 0,
		// 	y: '30rem',
		// 	duration: 1.1,
		// 	stagger: 0.1
		// }, 0.1);
		tl.fadeUp( $(el).find('.sre'), {
			duration: 1.15,
			yOrigin: '30rem'
		}, 0.1 )
	// }
	tl.play();
	
});

$('body').on('reveal-ott-slidemobile', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	if ( MQ(768) ) {
		$(el).find('.slideshow__item').each(function(i, el){
			$(el).addClass('scroll-reveal-fadeup-fake');
			setTimeout(function() {
				$(el).addClass('is-visible');
			}, i * 100 + 20);
		});
	}
	else {
		$(el).find('.slideshow__wrap').each(function(i, el){
			$(el).addClass('scroll-reveal-fadeup-fake');
			setTimeout(function() {
				$(el).addClass('is-visible');
			}, i * 100 + 20);
		});
	}
	tl.play();
	
});

$('body').on('reveal-ott-slidemobileb', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	if ( MQ(768) ) {
		$(el).find('.slideshow__item').each(function(i, el){
			$(el).addClass('scroll-reveal-fadein-fake');
			setTimeout(function() {
				$(el).addClass('is-visible');
			}, i * 100 + 20);
		});
	}
	else {
		$(el).find('.slideshow__wrap').each(function(i, el){
			$(el).addClass('scroll-reveal-fadein-fake');
			setTimeout(function() {
				$(el).addClass('is-visible');
			}, i * 100 + 20);
		});
	}
	tl.play();
	
});

$('body').on('reveal-ott-map', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	$(el).find('.ott__map__content__item').each(function(i, el){
		// $(el).addClass('scroll-reveal-fadeup-fake');
		setTimeout(function() {
			$(el).addClass('is-visible');
		}, (i+2) * 100 + 20);
	});
	tl.play();
	
});

$('body').on('reveal-ott-pageheader', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// $(el).find('.pageheader__page__header__media__wrap').each(function(i, el){
	// 	setTimeout(function() {
	// 		$(el).addClass('is-visible');
	// 		// $(el).addClass('is-visible');
	// 	}, i * 100 + 20);
	// });
	tl.fromTo($(el), 0.1, {
		opacity: 0,
	}, {
		opacity: 1
	}, 0);
	tl.from( $(el).find('.pageheader__page__header__media'), {
		opacity: 0,
		duration: 1.7
	}, 0 )
	// tl.deroul( $(el).find('.pageheader__page__header__media'), {
	// 	y: '-100%',
	// 	ease: Power2.easeInOut,
	// 	ease: CustomEase.create("custom", "M0,0 C0.134,0.017 0.242,0.036 0.322,0.13 0.401,0.223 0.449,0.367 0.502,0.506 0.546,0.622 0.62,0.824 0.726,0.916 0.799,0.98 0.869,1 1,1 "),
	// 	duration: 1.7
	// }, 0);
	// if ( MQ(768) ) {
		if ( MQ(768) && $(el).find('.pageheader__page__header__texte__1').length && $(el).find('.pageheader__page__header__texte__2').length ){
			tl.from( $(el).find('.sre'), {
				ease: 'power2.out',
				opacity: 0,
				x: function(i){
					if ( i == 0 ){
						return '60rem';
					}
					if ( i == 1 ){
						return '-60rem';
					}
					return 0;
				},
				y: function(i){
					if ( i == 2 ){
						return '-30rem';
					}
					return 0;
				},
				// duration: 1.1,
				duration: function(i){
					return 1.1 + ( ( 2 -i ) * 0.1 )
				},
				stagger: 0.1
			}, 0.6);
		}
		else {
			tl.from( $(el).find('.sre'), {
				ease: 'power2.out',
				opacity: 0,
				y: '-30rem',
				// duration: 1.1,
				duration: function(i){
					return 1.1 + ( ( 2 -i ) * 0.1 )
				},
				stagger: 0.1
			}, 0.6);

		}

	// }
	// else {
		
	// }

	// tl.play();
	setTimeout(function() {
		tl.play();
	}, 25);
	
});

$('body').on('reveal-bloc-prod', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	if ( MQ(768) ) {
		var direction = 'right';
		var offset = '30rem';
		if ( isLeft($(el).find('.prods__blocs__visuel')) ){
			direction = 'left';
			offset = '-30rem';
		}
		tl.deroul( $(el).find('.prods__blocs__visuel'), {
			ease: Power2.easeInOut,
			duration: 1.1,
			direction: direction
		});
		tl.from( $(el).find('.prods__blocs__logo'), {
			ease: Power2.easeOut,
			opacity: 0,
			x: offset,
			duration: 1.1,
			stagger: 0.1
		}, 0.15);
		tl.from( $(el).find('.prods__blocs__item__txts__inner'), {
			ease: Power2.easeOut,
			opacity: 0,
			y: '30rem',
			duration: 1.1,
			stagger: 0.1
		}, 0.3);
	}
	else {
		// var els = $(el).find('.about__blocs__visuel').add($(el).find('.about__blocs__txts').children());
		var els = $(el).find('.prods__blocs__visuel').get().concat($(el).find('.prods__blocs__logo').get());
		// els = els.get().concat($(el).find('.prods__blocs__item__txts__inner').children().get());
		els = els.concat($(el).find('.prods__blocs__item__txts__inner').children().get());
		tl.from( els, {
			ease: Power2.easeOut,
			opacity: 0,
			y: '30rem',
			duration: 1.1,
			stagger: 0.1
		}, 0.1);
	}
	tl.play();
	
});

$('body').on('reveal-bloc-news-head', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var p = $(el).parent();
	// alert(p.get(0))
	tl.deroul( $(p).find('.news__top'), {
		y: '-100%',
		ease: Power2.easeInOut,
		duration: 1.5
	});
	
	if ( MQ(768) ) {
		
		var els = $(p).find('.newss__menu__item').get().concat($(p).find('.newss__list__top__item').get());
		var delay = $(p).find('.newss__menu__item').length * 0.15;
		tl.fadeUp( els, {
			yOrigin: '30rem',
			stagger: 0.15,
			duration: 1.15
		}, 0.95 - delay);
	}
	else {
		var els = $(p).find('.newss__list__item__top__pho').get().concat($(p).find('.newss__menu__item').get());
		tl.fadeUp( els, {
			yOrigin: '30rem',
			stagger: 0.15,
			duration: 1.15
		}, 0.5);
	}
	tl.play();
	
});

$('body').on('reveal-bloc-news-detail-head', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var p = $(el).parent();
	// alert(p.get(0))
	tl.deroul( $(p).find('.news__top'), {
		y: '-100%',
		ease: Power2.easeInOut,
		duration: 1.5
	});
	
	if ( MQ(768) ) {
		var els = $(p).find('.newss__aside__inner').children().get().concat($(p).find('.newss__detail').get());
		var delay = $(p).find('.newss__aside__inner').children().length * 0.15;
		tl.fadeUp( els, {
			yOrigin: '30rem',
			stagger: 0.15,
			duration: 1.15
		}, 0.95 - delay);
	}
	else {
		var els = $(p).find('.newss__aside__inner').children().get().concat($(p).find('.newss__detail').get());
		tl.fadeUp( els, {
			yOrigin: '30rem',
			stagger: 0.15,
			duration: 1.15
		}, 0.5);
	}
	tl.play();
	
});

$('body').on('reveal-home-slideshow', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var wrapmask = $(el).find('.home__slideshow__items').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.from( wrapmask.parents, 1, {
		opacity: 0,
		ease: Power0.easeOut
	}, 1 )
	tl.to( wrapmask.masks, 2, {
		y: '100%',
		ease: Power2.easeInOut
	}, 0 )
	tl.from( wrapmask.childs, 2, {
		y: '-10%',
		ease: Power2.easeInOut
	}, 0 )
	tl.from( $(el).find('.home__slideshow__navs'), 1, {
		opacity: 0,
		ease: Power0.easeInOut
	}, 1.75 )
	tl.play()
	return;
	// var sp = new SplitText(el, {type:'lines,words,chars'});
	var sp = new SplitText(el, {type:'chars'});
	tl.staggerFromTo( sp.chars, 1, {
		opacity: 0
	}, {	
		opacity: 1,
		ease: Power0.easeOut
	}, 0.05, 0 );
	tl.fromTo( $('.svg__epi--left'), 1, {
		opacity: 0,
		x: '100%',
		ease: Power1.easeOut
	}, {
		opacity: 1,
		x: '0%',
		ease: Power1.easeOut
	}, '-=1' );
	tl.fromTo( $('.svg__epi--right'), 1, {	
		opacity: 0,
		x: '-100%',
		ease: Power1.easeOut
	}, {
		opacity: 1,
		x: '0%',
		ease: Power1.easeOut
	}, '-=1' );
	// tl.play();
	TweenMax.fromTo( tl, 2, {
		progress: 0
	}, {
		progress: 1,
		ease: Power1.easeOut
	} );
});


$('body').on('reveal-fadein', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget);
	// TweenMax.fromTo( el, 0.75, {
	// 	opacity: 0
	// }, {
	// 	opacity: 1,
	// 	ease: Power1.easeOut
	// } );
});

$('body').on('reveal-fadeup', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget).addClass('reveal');
});

$('body').on('reveal-faderight', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget).addClass('reveal');
});

$('body').on('reveal-drawright', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget).addClass('reveal');
});

$('body').on('reveal-css', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget).addClass('reveal');
});

$('body').on('reveal-pp-picto', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget).addClass('reveal');
	gsap.set( el, {x:0,y:0} );
});

$('body').on('reveal-css-lines', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var delay = parseFloat(el.attr('data-lines-delay')) || 0.1;
	var classname = el.attr('class').split(' ');
	for(var i=0,j=classname.length;i<j;i++){
		var d = classname[i];
		if ( d.indexOf('reveal-') === 0 ) {
			classname = d;
			break;
		}
	}
	el.attr('debug-classname', classname+' '+delay);
	var lines = new SplitText(el.get(0), {type:'lines'}).lines;
	$(lines).addClass('scroll-reveal is-revealed '+classname);
	$(lines).each(function(i, eel){
		eel.offsetWidth;
	})
	$(el).removeClass('scroll-reveal '+classname);
	setTimeout(function() {
		var tl = new TimelineMax({paused : true});
		tl.staggerTo( lines, 0, {
			className: '+=reveal',
			ease: Linear.easeNone
		}, delay );
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-slideshow', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var wrapmask = el.wrapmask({cn:'ovh rel',mask:''});
	var p = wrapmask.parents;
	p.addClass('ppppp');
	var wrapmask2 = wrapmask.parents.wrapmask({cn:'ovh rel',mask:''});
	setTimeout(function() {
		var tl = new TimelineMax({paused : true});
		tl.from( p, 1, {
			y: '-100%',
			ease: Power2.easeOut
		}, 0 );
		tl.from( el, 1, {
			y: '80%',
			ease: Power2.easeOut
		}, 0 );
		var txt = $(el).find('.home__slideshow__item__txts__inner').eq(0);
		if ( txt ) {
			var lines = new SplitText(txt, {type:'lines'});
			tl.from( lines.lines, 1.3, {
				x: '-100rem',
				opacity: 0,
				stagger: 0.15,
				ease: Power2.easeOut
			}, 0.3 );
		}
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-actu-visuold', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget).find('img');
	var wrapmask = el.wrapmask({cn:'ovh rel',mask:''});
	var p = wrapmask.parents;
	p.addClass('ppppp');
	var wrapmask2 = wrapmask.parents.wrapmask({cn:'ovh rel',mask:''});
	setTimeout(function() {
		var tl = new TimelineMax({paused : true});
		tl.from( p, 1, {
			y: '-100%',
			ease: Power2.easeOut
		}, 0 );
		tl.from( el, 1, {
			y: '80%',
			ease: Power2.easeOut
		}, 0 );
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-actu-visu', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget).find('img');
	var wrapmask = el.wrapmask({cn:'ovh rel',mask:''});
	var p = wrapmask.parents;
	p.addClass('ppppp');
	var wrapmask2 = wrapmask.parents.wrapmask({cn:'ovh rel',mask:''});
	setTimeout(function() {
		var tl = new TimelineMax({paused : true});
		tl.deroul( $(evt.currentTarget).find('img'), {
			y: '-100%',
			ease: Power2.easeOut
		});
		tl.from( $('.actu__title__bg'), 1, {
			scale: 0,
			opacity: 0,
			transformOrigin: '0% 0%',
			ease: Power2.easeOut
		}, 0.3 )
		var txt = $('.actu__title u').eq(0);
		var lines = new SplitText(txt, {type:'lines'});
		tl.from( lines.lines, 1.3, {
			x: '-100rem',
			opacity: 0,
			stagger: 0.15,
			ease: Power2.easeOut
		}, 0.6 );
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-service-bg-scaledown', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	setTimeout(function() {
		var tl = new TimelineMax({paused : true});
		tl.from( el, 1.3, {
			scaleY: 0,
			transformOrigin: '0% 0%',
			ease: Power2.easeOut
		});
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-service-line', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var opts = {
		o: '100% 0%',
		direction: 'left'
	};
	if ( parseInt(el.attr('data-index'), 10) % 2 == 1 ) {
		opts = {
			o: '0% 0%',
			direction: 'right'
		};
	}
	var tl = new TimelineMax({paused : true});
	// tl.from( $(el).find('.service__bloc__item__visu__line'), 0.6, {
	// 	scaleX: 0,
	// 	transformOrigin: opts.o,
	// 	ease: Power2.easeOut
	// }, 0);
	tl.deroul( $(el).find('.service__bloc__item__visu__visu img'), {
		direction: opts.direction,
		factor: 0.5
	}, 0.1);
	tl.fadeUp( $(el).find('.service__bloc__item__txts > div'), {
		yOrigin: '30rem',
		stagger: 0.10
	}, 0.2 );
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-slideshow-col', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.deroul( $(el), {
		direction: el.attr('data-way')
	}, 0);
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-projet-timings', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.projets__timings__col__bg'), 1, {
		scaleX: 0,
		transformOrigin: '100% 50%',
		ease: Power2.easeOut,
		clearProps: 'all'
	}, 0);
	tl.from( $(el).find('.projets__timings__title__inner, .projets__timings__item__dots, .projets__timings__item__picto, .projets__timings__item__gare__wrap, .projets__timings__item__arc__wrap'), 0.7, {
		x: '30rem',
		opacity: 0,
		ease: Power2.easeOut,
		stagger: 0.075
	}, 0.2);
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-projet-chiffres', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.projets__chiffres__bg'), 1, {
		scaleX: 0,
		transformOrigin: '0% 50%',
		ease: Power2.easeOut,
		clearProps: 'all',
	}, 0);
	tl.from( $(el).find('.projets__chiffres__title, .projets__chiffres__item__picto, .projets__chiffres__item__txts'), 0.7, {
		x: '-30rem',
		opacity: 0,
		ease: Power2.easeOut,
		stagger: 0.075
	}, 0.2);
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-projet-certifs', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.from( $(el).find('.projets__certifs__bg'), 1, {
		scaleX: 0,
		transformOrigin: '100% 50%',
		ease: Power2.easeOut,
		clearProps: 'all'
	}, 0);
	tl.from( $(el).find('[data-move="1"]'), 0.7, {
		x: '30rem',
		opacity: 0,
		ease: Power2.easeOut,
		stagger: 0.075
	}, 0.3);
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-projet-footer', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var els = $('.projets__footer__sep')
		.add('.projets__footer__item--0 .projets__footer__item__picto')
		.add('.projets__footer__item--0 .projets__footer__item__nb')
		.add('.projets__footer__item--0 .projets__footer__item__txtbold')
		.add('.projets__footer__item--0 .projets__footer__item__txt')
		.add('.projets__footer__item--0 .projets__footer__item__sep')
		.add('.projets__footer__item--1 .projets__footer__item__nb')
		.add('.projets__footer__item--1 .projets__footer__item__txtbold')
		.add('.projets__footer__item--1 .projets__footer__item__txt')
		.add('.projets__footer__item--1 .projets__footer__item__picto')
		.add('.projets__footer__item--1 .projets__footer__item__sep')
		.add('.projets__footer__item--2 .projets__footer__item__nb')
		.add('.projets__footer__item--2 .projets__footer__item__txtbold')
		.add('.projets__footer__item--2 .projets__footer__item__txt')
		.add('.projets__footer__item--2 .projets__footer__item__picto')
	tl.fadeUp( els, {
		yOrigin: '30rem',
		stagger: 0.07
	}, 0);
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-evidence-header', '.scroll-reveal', function(evt){
	// var el = $(evt.currentTarget).addClass('reveal');
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	tl.to( $('.header__inner'), 0, {
		opacity: 1,
		ease: Power0.easeOut
	}, 0.01 );

	tl.fadeUp( $('.header__logo__wrap, .menu__item__li, .header__linkedin__wrap, .header__toggler__wrap '), {
		yOrigin: '-50rem',
		stagger: 0.10
	}, 0 );
	setTimeout(function() {
		tl.play();
	}, 10);
});

$('body').on('reveal-vin-head', '.scroll-reveal', function(evt){
	var tl = new TimelineMax({paused : true});
	tl.from( $('.vin__head__retour__svg'), 1, {
		opacity: 0
	}, 0 )
	tl.from( $('.vin__head__visuel__wrap'), 1.5, {
		opacity: 0
	}, 0.4 )
	tl.from( $('.vin__head__cat__title'), 1, {
		opacity: 0
	}, 0.4 )
	tl.from( $('.vin__head__title'), 1, {
		opacity: 0
	}, 0.6 )
	tl.from( $('.vin__head__menu'), 1, {
		opacity: 0
	}, 0.8 )
	tl.from( $('.vin__head__epi'), 1, {
		opacity: 0
	}, 1.2 )
	tl.from( $('.vin__head__retour__cta__wrap'), 1.5, {
		opacity: 0
	}, 1.4 )

	tl.play()
});

$('body').on('reveal-contact-form', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	var wrapmask = el.find('.form__group').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.staggerTo( wrapmask.masks, 1, {
		// x: '100%',
		y: '100%',
		ease: Power2.easeOut
	}, 0.075 );

	tl.play()
});

$('body').on('reveal-header', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	var tl = new TimelineMax({paused : true});
	// var wrapmask = el.find('.form__group').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.fromTo( el, 1, {
		opacity: 0,
		y: '-25%'
	}, {
		opacity: 1,
		// x: '100%',
		y: '0%',
		ease: Power2.easeOut
	} );

	tl.play()
});

$('body').on('reveal-quote', '.scroll-reveal', function(evt){
	// set final bg position
	var el = $(evt.currentTarget);
	var ww = $(window).width();
	var elw = $(el).outerWidth();
	$(el).find('.domaine__quote__bg').css({
		left: Math.ceil( (ww - elw) / 2 ) * -1,
		right: 'auto',
		width: ww
	});
	var tl = new TimelineMax({paused : true});
	// var wrapmask = el.find('.form__group').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.fromTo( $(el).find('.domaine__quote__bg'), 1, {
		opacity: 0,
		x: '-100%'
	}, {
		opacity: 1,
		x: '0%',
		ease: Circ.easeInOut
	} );

	tl.play()
});

$('body').on('reveal-equipe-main-item', '.scroll-reveal', function(evt){
	// set final bg position
	var el = $(evt.currentTarget);
	var decal = 0; 
	if ( el.hasClass('equpe__main__item__wrap--1') ) {
		decal = 0.1;
	}
	var tl = new TimelineMax({paused : true});
	// var wrapmask = el.find('.form__group').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.fromTo( $(el).find('.equpe__main__item__nom'), 0.7 + decal, {
		x:'-10rem',
		opacity: 0
	}, {
		x:'0rem',
		opacity: 1,
		ease: Circ.easeOut
	} );
	tl.fromTo( $(el).find('.equpe__main__item__visu__arrow__mask'), 0.75, {
		drawSVG:'0% 100%'
	}, {
		drawSVG:'100% 100%',
		ease: Circ.easeOut
	}, 0.25 + decal );
	tl.fromTo( $(el).find('.equpe__main__item__visu'), 1, {
		x:'0rem',
		opacity: 0
	}, {
		x:'0rem',
		opacity: 1,
		ease: Circ.easeOut
	}, 0.5 + decal );
	tl.fromTo( $(el).find('.equpe__main__item__txt'), 0.75, {
		y:'3rem',
		opacity: 0
	}, {
		y:'0rem',
		opacity: 1,
		ease: Circ.easeOut
	}, 0.75 + decal );
	
	// tl.timeScale(0.2);
	tl.play();
});

$('body').on('reveal-home-baseline', '.scroll-reveal', function(evt){
	// set final bg position
	var el = $(evt.currentTarget);
	var st =  new SplitText(el, {type:'lines,words,chars'});
	
	var tl = new TimelineMax({paused : true});
	// var wrapmask = el.find('.form__group').wrapmask({cn:'ovh rel',mask:'mask'});
	tl.staggerFrom( st.chars, 0.6, {
		// scale:0.5,
		opacity: 0,
		ease: Power0.easeOut
	}, 0.035 );

	// alert( cymasmooth.pagesViewed )

	var baseline_delay = 20;
	if ( cymasmooth.pagesViewed == 1 ) {
		logo_anim();
		baseline_delay = 4000;
	}

	
	// tl.timeScale(0.2);
	setTimeout(function() {
		tl.play();
	}, baseline_delay);
});

$('body').on('reveal-line-verti', '.scroll-reveal', function(evt){
	var el = $(evt.currentTarget);
	
	var tl = new TimelineMax({paused : true});
	tl.fromTo( $(el).find('.line__n__circle__circle'), 0.4, {
		opacity: 0
	}, {
		opacity: 1,
		ease: Power0.easeOut
	});
	var h = $(el).find('.line__n__circle__line').height();
	tl.fromTo( $(el).find('.line__n__circle__line'), h / 1000, {
		scaleY: 0,
		transformOrigin: '0% 0%'
	}, {
		scaleY: 1,
		ease: Power1.easeInOut
	}, 0.2);
	tl.play();
});
